import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const SummaryHolder = styled(Flex)`
    flex-direction: column;
`;
export const SummaryItemFlexColumn = styled(Flex)`
    flex-direction: column;
    padding: 12px 0;
    gap: 8px;
`;

export const SummaryItem = styled(Flex)`
    justify-content: space-between;
`;

export const SummaryItemText = styled(Text)`
    color: ${colorsPalettes.carbon[500]};
`;

export const SummaryDiscountItemText = styled(SummaryItemText)`
    color: ${colorsPalettes.green["400_P"]};
`;

export const SummaryTotalItemText = styled(SummaryItemText)`
    font-weight: 700;
`;

export const SummaryDivider = styled.div`
    height: 1px;
    background-color: ${colorsPalettes.carbon[100]};
`;

export const SummaryTooltip = styled(Tooltip)`
    width: 250px;
    z-index: 2001;
`;
